import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import Image from '@atlaskit/image';
import { token } from '@atlaskit/tokens';
import slackIcon from './assets/slack.svg';
import teamsIcon from './assets/teams.svg';

interface ConnectButtonProps {
	onClick: () => void;
}

export const MicrosoftTeamsConnectButton = ({ onClick }: ConnectButtonProps): ReactNode => (
	<IntegrationButton
		testId="third-party-nudge.ui.third-party-nudge-flag.connect-button.both-find-out-more-button"
		onClick={onClick}
	>
		<IntegrationButtonContent>
			{/* No need to specify height since the image resizes by proportion automatically */}
			<Image src={teamsIcon} alt="Teams icon" width={16} />
			<IntegrationName>Microsoft Teams</IntegrationName>
		</IntegrationButtonContent>
	</IntegrationButton>
);

export const SlackConnectButton = ({ onClick }: ConnectButtonProps): ReactNode => (
	<IntegrationButton
		testId="third-party-nudge.ui.third-party-nudge-flag.connect-button.both-connect-slack-button"
		onClick={onClick}
	>
		<IntegrationButtonContent>
			{/* No need to specify height since the image resizes by proportion automatically */}
			<Image src={slackIcon} alt="Slack icon" width={16} />
			<IntegrationName>Slack</IntegrationName>
		</IntegrationButtonContent>
	</IntegrationButton>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IntegrationName = styled.span({
	fontWeight: 600,
	fontSize: token('space.150', '12px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IntegrationButtonContent = styled.div({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'center',
	gap: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IntegrationButton = styled(Button)({
	flex: 1,
});
